import React from 'react'
import styled from 'styled-components'
import { colors } from './helpers'
import { Label, Error, Text, Span } from './Typography'
import { Flex, Box } from './Layout'
import Icon from './Icon'
import {
  space,
  width,
  color,
  flex,
  order,
  fontSize,
  alignSelf,
  flexWrap,
  flexDirection,
  alignItems,
  justifyContent,
  borders,
  minWidth,
  minHeight,
  borderRadius,
  size,
  height,
  maxWidth,
  textAlign,
  boxShadow,
  borderColor,
  position,
  display,
  top,
  bottom,
  left,
  right,
  zIndex
} from 'styled-system'

const InputComponent = styled.input`
  border-radius: 8px;
  background: ${(props) => {
    if (props.disabled) {
      return '#EDF2F7'
    }
    return props.dark ? '#EDF2F7' : '#ffffff'
  }};
  height: ${(props) => (props.large ? '40px' : '36px')};
  margin: 0px;
  margin-bottom: 0px;
  box-shadow: 0px 1px 2px rgba(50, 50, 71, 0.08), 0px 0px 1px rgba(50, 50, 71, 0.2);
  border-radius: 6px;
  color: white;
  display: inline-block;
  border: none;
  ${(props) => (props.border ? `border: ${props.border};` : '')}
  font-size: ${(props) => (props.large ? '15px' : '14px')};
  padding-left: 24px;
  padding-right: 24px;
  text-decoration: none;
  color: ${colors.textDark};
  transition: background 250ms ease-in-out, transform 150ms ease;
  -webkit-appearance: none;
  -moz-appearance: none;
  ${position};
  ${width};
  ${space};
  ${fontSize};
  ${color};
  ${flex};
  ${order};
  ${alignSelf};
  ${borders};
  ${borderColor};
  ${minWidth};
  ${minHeight};
  ${borderRadius};
  ${size};
  ${height};
  ${textAlign};
  ${maxWidth};
  ${boxShadow};
  ${display};
  ${top};
  ${bottom};
  ${left};
  ${right};
  ${zIndex};
  ::-webkit-input-placeholder {
    font-family: 'Inter', sans-serif;
  }
  ::-moz-placeholder {
    font-family: 'Inter', sans-serif;
  }
  :-ms-input-placeholder {
    font-family: 'Inter', sans-serif;
  }
  :-moz-placeholder {
    font-family: 'Inter', sans-serif;
  }
  ${(props) => (props.error ? `border: 1.5px solid ${colors.error};` : '')}
  &&:focus {
    padding-left: 22.5px;
    border: 1.5px solid #7895ff;
    box-shadow: 0px 0px 0px 2px rgba(76, 111, 255, 0.3);
  }
`

const MaxLength = styled(Text)`
  font-size: 12px;
  position: absolute;
  right: 8px;
  bottom: 0px;
  color: ${colors.textLight};
`

const TextPostFixComponent = styled(Text)`
  font-size: ${(props) => (props.largeTextPostFix ? '14px' : '12px')};
  position: absolute;
  right: ${(props) => (props.largeTextPostFix ? '24px' : '8px')};
  bottom: 5px;
  color: ${colors.textLight};
`

const Tooltip = styled(Icon)`
  cursor: pointer;
`

const NoWrapLabel = styled(Label)`
  white-space: nowrap;
`

export const Input = ({ label, error, mb, mr, ml, mt, width, textPostFix, largeTextPostFix, tooltip, optional, ...rest }) => {
  return (
    <Flex borderRadius="4px" position="relative" width={width} flexDirection="column" mb={mb} mr={mr} mt={mt} ml={ml}>
      {label && (
        <>
          <NoWrapLabel display="flex" data-tip={tooltip}>
            {label}{' '}
            {tooltip && (
              <Box ml="8px" data-tip={tooltip}>
                <Tooltip width="16" height="16" icon="tooltip-grey" />
              </Box>
            )}
          </NoWrapLabel>
        </>
      )}
      <InputComponent error={error} {...rest} />
      {rest.maxLength && rest.value ? <MaxLength>{rest.maxLength - rest.value.length}</MaxLength> : null}
      {textPostFix ? <TextPostFixComponent largeTextPostFix={largeTextPostFix}>{textPostFix}</TextPostFixComponent> : null}
      {error && (
        <Error mt="8px" mb="-22px">
          {error}
        </Error>
      )}
    </Flex>
  )
}

export const SideInput = (props) => {
  return (
    <Flex mb="16px" px="24px" alignItems="center" justifyContent="space-between">
      <Flex width="auto">
        <Label mb="0">{props.label}</Label>
        {props.tooltip && (
          <Box ml="8px" data-tip={props.tooltip}>
            <Tooltip width="16" height="16" icon="tooltip-grey" />
          </Box>
        )}
      </Flex>
      <Input {...props} width="150px" label={undefined} />
    </Flex>
  )
}

export const TextArea = styled.textarea`
  height: 30px;
  border-radius: 8px;
  background: #edf2f7;
  box-shadow: 0px 1px 2px rgba(50, 50, 71, 0.08), 0px 0px 1px rgba(50, 50, 71, 0.2);
  display: inline-block;
  padding: 25px;
  border: none;
  text-decoration: none;
  transition: background 250ms ease-in-out, transform 150ms ease;
  -webkit-appearance: none;
  -moz-appearance: none;
  resize: none;
  ${position};
  ${width};
  ${space};
  ${fontSize};
  ${color};
  ${flex};
  ${order};
  ${alignSelf};
  ${borders};
  ${borderColor};
  ${minWidth};
  ${minHeight};
  ${borderRadius};
  ${size};
  ${height};
  ${textAlign};
  ${maxWidth};
  ${boxShadow};
  ${display};
  ${top};
  ${bottom};
  ${left};
  ${right};
  ${zIndex};
`
